(() => {
  const priceSelector = '.collection-price-main';
  let frame = 0;

  function splitPriceParts(priceText) {
    const match = `${priceText || ''}`.trim().match(/^([^0-9]*)([0-9,]+)(?:\.([0-9]{2}))?$/);

    if (!match) return null;

    return {
      currency: match[1] || '$',
      dollars: match[2],
      cents: match[3] || '00'
    };
  }

  function formatPrice(price) {
    if (
      price.querySelector(':scope > .collection-price-currency') &&
      price.querySelector(':scope > .collection-price-dollars') &&
      price.querySelector(':scope > .collection-price-decimal') &&
      price.querySelector(':scope > .collection-price-cents')
    ) {
      return;
    }

    const parts = splitPriceParts(price.textContent);
    if (!parts) return;

    const currency = document.createElement('span');
    currency.className = 'collection-price-currency';
    currency.textContent = parts.currency;

    const dollars = document.createElement('span');
    dollars.className = 'collection-price-dollars';
    dollars.textContent = parts.dollars;

    const decimal = document.createElement('span');
    decimal.className = 'collection-price-decimal';
    decimal.textContent = '.';

    const cents = document.createElement('span');
    cents.className = 'collection-price-cents';
    cents.textContent = parts.cents;

    price.classList.add('collection-price-main-split');
    price.replaceChildren(currency, dollars, decimal, cents);
  }

  function syncProductPagePrices(root = document) {
    if (root.nodeType === Node.ELEMENT_NODE && root.matches(priceSelector)) {
      formatPrice(root);
    }

    root.querySelectorAll?.(priceSelector).forEach(formatPrice);
  }

  function parseSkuMap(root) {
    const source = root.querySelector('[data-product-sku-map]');
    if (!source) return {};

    try {
      return JSON.parse(source.textContent || '{}');
    } catch (error) {
      console.warn('Product SKU map parse error', error);
      return {};
    }
  }

  function getSelectedVariantId(root) {
    const cartVariantInput = root.querySelector('input.product-variant-id[name="id"]');
    if (cartVariantInput && cartVariantInput.value) return cartVariantInput.value;

    const variantInput = root.querySelector('input[name="variant-id"]:checked, input[name="variant-id"][type="hidden"]');
    if (variantInput && variantInput.value) return variantInput.value;

    const variantSelect = root.querySelector('select[name="variant-id"]');
    if (variantSelect && variantSelect.value) return variantSelect.value;

    return '';
  }

  function syncProductPageSku() {
    const productRoot = document.getElementById('main-product');
    if (!productRoot) return;

    const skuLine = productRoot.querySelector('[data-product-sku]');
    const skuValue = productRoot.querySelector('[data-product-sku-value]');
    if (!skuLine || !skuValue) return;

    const skuByVariantId = parseSkuMap(productRoot);
    const sku = skuByVariantId[getSelectedVariantId(productRoot)] || '';
    skuValue.textContent = sku;
    skuLine.classList.toggle('hidden', !sku);
  }

  function scheduleSync() {
    if (frame) return;

    frame = requestAnimationFrame(() => {
      frame = 0;
      syncProductPagePrices();
      syncProductPageSku();
    });
  }

  function scheduleSkuSync() {
    requestAnimationFrame(syncProductPageSku);
    setTimeout(syncProductPageSku, 80);
    setTimeout(syncProductPageSku, 250);
  }

  function initialize() {
    syncProductPagePrices();
    syncProductPageSku();

    const root = document.getElementById('root');
    if (!root) return;

    new MutationObserver(scheduleSync).observe(root, {
      childList: true,
      subtree: true
    });

    const productRoot = document.getElementById('main-product');
    if (productRoot) productRoot.addEventListener('change', scheduleSkuSync, true);
  }

  window.syncProductPagePrices = syncProductPagePrices;
  window.syncProductPageSku = syncProductPageSku;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
